import React from 'react';
import { Container, Row, Col } from "react-bootstrap"
import ModalIFA from "../Modal/ModalIFA"
import FooterText from "./FooterText"
import socialIcons from "./FooterSocial"
import FooterMenuColTwo from "./FooterMenuCol"
import FooterMenuColOne from "./FooterMenu"
import FooterFindExpert from "./FooterFindExpert"
import FooterPromoVideo from "./FooterPromoVideo"

import Icon from "../../assets/JMFinnLogo.svg";

const SiteFooter = () => {

  return (
    <>
      <FooterFindExpert />
      <footer className="footer">
        <Container fluid>
          <Row className="g-0">
            <Col xs={12} md={4} lg={2} className="footer-col">
              <FooterMenuColOne />
              {/*
              // output menu data
              // options menuName: machine menu name, menuClass: string of classed to be added to the ul
              // only outputs the ul so that the <nav> wrapper can be customised depending on the type of menu required
              */}
              {/* <Nav className="navbar navbar-expand-lg navbar-dark bg-dark">
                <Menu menuName={`footer`} />
              </Nav> */}
              {/* // menu :: end */}
            </Col>
            <Col xs={12} md={4} lg={2} className="footer-col">
              <FooterMenuColTwo />
            </Col>
            <Col xs={12} md={4} lg={3} className="footer-col">
            <h3>Follow us</h3>
            <ul className="social-share">
              {socialIcons.map((item, index) => {
                return <li key={index}><a href={item.url} target="_blank" rel="noopener noreferrer" aria-label={item.ariaLabel}>
                  {item.icon}
                </a></li>
              })}
            </ul>
            </Col>
            <Col xs={12} md={12} lg={4}  className="footer-col">
              <FooterText />
            </Col>
          </Row>
          <Row className="g-0">
            <Col sm={12} md={6} lg={2} className="footer-col">
              <a href="/" aria-label="J.M.Finn&Co.Ltd logo"><Icon width="140" /></a>
            </Col>
            <Col sm={12} md={6} lg={3} className="footer-col">
              <span>
                © {new Date().getFullYear()} J.M.Finn&Co.Ltd
              </span>
            </Col>
          </Row>
        </Container>
        <ModalIFA />
        <FooterPromoVideo />
      </footer>
    </>
  )

}

export default SiteFooter
